<template>
  <div v-if="!dataObject[field] || uploadNew" class="w-full">
    <FilePondUploadWidget :ref="`fileUpload`" @fileUpdated="fileUpdated(dataObject, field)"/>
    <div v-if="fileHistory[field]" class="text-right pt-">
      <button @click="uploadNew = false" class="btn-sm btn-red-outline mt-2">Cancel New Upload</button>
    </div>
  </div>
  <div v-else class="w-full">
    <div class="bg-gray-200 px-3 py-4 rounded-md text-right" :class="{flex: simpleDisplayMode, 'items-center': simpleDisplayMode}">
      <template v-if="!simpleDisplayMode">
        <div v-if="!safeURL.includes('.pdf')">
          <img :src="dataObject[field]" class="w-full"/>
        </div>
        <iframe v-else class="w-full h-96 border" style="height: 25rem;" :src="dataObject[field]"></iframe>
      </template>
      <template v-else>
        <div v-if="!safeURL.includes('.pdf')">
          <img :src="dataObject[field]" class="w-40 mx-auto"/>
        </div>
        <iframe v-else class="w-40 border mx-auto" style="height: 13rem;" :src="dataObject[field]"></iframe>
      </template>
      <div class="mt-4 w-full flex flex-col justify-between items-center text-right">
        <display-file-type-field :url="dataObject[field]" :title="field"/>
        <div class="flex justify-between mt-1">
          <button @click="uploadNewFile(dataObject, field)" class="btn-xs btn-gray-outline" type="button">
            Upload New File
          </button>
          <button @click="reset(dataObject, field)" class="btn-xs btn-link">Remove</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import FilePondUploadWidget from '@/components/FilePondUploadWidget.vue'
import 'filepond/dist/filepond.min.css'
import 'filepond-plugin-image-preview/dist/filepond-plugin-image-preview.min.css'

export default {
  components: {
    FilePondUploadWidget
  },
  props: {
    dataObject: Object,
    field: String,
    simpleDisplayMode: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      fileHistory: {},
      uploadNew: false
    }
  },
  methods: {
    fileUpdated (s, field) {
      let widget = this.$refs[`fileUpload`]
      if (Array.isArray(widget)) {
        widget = widget[0]
      }
      this.$set(s, field, widget.value)
      this.$emit('change', s)
      this.uploadNew = false
    },
    uploadNewFile (s, field) {
      this.$set(this.fileHistory, field, s[field])
      this.uploadNew = true
    },
    reset (s, field) {
      this.$set(s, field, null)
      this.$emit('change', s)
    }
  },
  computed: {
    safeURL () {
      return this.dataObject[this.field] || ''
    }
  }
}
</script>

<style>

</style>
